import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { cn, isRTL } from '../../lib/utils';

interface AppLayoutProps {
  children: React.ReactNode;
  userType: string;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, userType }) => {
  const { i18n } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const rtl = isRTL(i18n.language);

  useEffect(() => {
    // Set document direction based on language
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language, rtl]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1280;
      setIsCollapsed(mobile);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar userType={userType} />
      <Navbar isCollapsed={isCollapsed} />
      <main
        className={cn(
          'pt-16 min-h-screen transition-all duration-300',
          isCollapsed ? (rtl ? 'mr-20' : 'ml-20') : (rtl ? 'mr-64' : 'ml-64')
        )}
      >
        <div className="p-3 sm:p-6 animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
